const makeStringMatcher = (stringToMatch = "") => (matcher) =>
  !!stringToMatch.match(matcher);

export default makeStringMatcher;
